import { getStrapiMedia } from "@repo/lib/utils";
import Image from "next/image";
import Link from "next/link";

const SocialLinks = ({ socialLinks }) => {
  if (socialLinks?.length === 0) return null;
  return (
    <div className="flex items-center space-x-3 rtl:space-x-reverse">
      {socialLinks?.map((item) => (
        <Link
          key={item.id}
          href={item.url || "#"}
          target="_blank"
          className="rounded-full bg-[#313131] p-2"
        >
          <Image
            src={getStrapiMedia(item.icon.url)}
            alt={item.icon.alternativeText}
            width={item.icon.width}
            height={item.icon.height}
            className="size-4"
          />
        </Link>
      ))}
    </div>
  );
};

export default SocialLinks;
